import texts from 'Components/texts.json';
import type { GradingValues } from 'Pages/vehicles/helpers/vehicle.schema';
import { GRADES } from 'Pages/vehicles/helpers/vehicle.schema';
import { capitaliseSentence } from 'Utilities/helpers';

const { BRONZE, GOLD, SILVER } = GRADES;

const formatVehicleGrade = (grade: GradingValues) => capitaliseSentence(grade);

export default {
	exteriorGrades: {
		bronze: formatVehicleGrade(BRONZE),
		gold: formatVehicleGrade(GOLD),
		silver: formatVehicleGrade(SILVER),
	},
	labels: {
		dents: texts.vehicleDetails.conditionAndDamage.dents,
		levels: 'Levels',
		paintworkProblems: texts.vehicleDetails.conditionAndDamage.paintworkProblems,
		scratchesAndScuffs: texts.vehicleDetails.conditionAndDamage.scratchesAndScuffs,
		scuffedAlloys: texts.vehicleDetails.wheelsAndTyres.scuffedAlloys,
		warningLightsOnDashboard: texts.vehicleDetails.conditionAndDamage.warningLightsOnDashboard,
		windscreenDamage: texts.vehicleDetails.conditionAndDamage.windscreenDamage,
	},
	modal: {
		disclaimer:
			'Every vehicle on Motorway is assigned an exterior condition grade based on the information provided by the seller. Although every effort has been made to give a full and accurate description of the vehicle, please allow for minor repairs and discrepancies when bidding.',
		title: 'Exterior grading',
	},
	values: {
		bronze: {
			dents: '2+ of various sizes',
			paintworkProblems: 'Panels may need paint',
			scratchesAndScuffs: 'Various sizes (8+ small, 2+ medium, 2+ large)',
			scuffedAlloys: 'May require refurbishment',
			warningLightsOnDashboard: 'May be displayed',
			windscreenDamage: 'May have chips',
		},
		gold: {
			dents: 'None declared',
			paintworkProblems: 'None declared',
			scratchesAndScuffs: 'Up to 3 small',
			scuffedAlloys: 'May require refurbishment',
			warningLightsOnDashboard: 'None declared',
			windscreenDamage: 'None declared',
		},

		silver: {
			dents: '1 small',
			paintworkProblems: 'Panels may need paint',
			scratchesAndScuffs: 'Various sizes (4-7 small, 1 medium, 1 large)',
			scuffedAlloys: 'May require refurbishment',
			warningLightsOnDashboard: 'None declared',
			windscreenDamage: 'None declared',
		},
	},
};
